export default "__VITE_ASSET__CZpr2Bh2__"